export default function marketSlideHover() {
    $(document).on('mouseenter', '.market-slide .link-overlay', function () {
        let $this = $(this).parents('.market-slide'),
            height = $this.innerHeight(),
            wrapperHeight = $this.find('.market-slide__wrap').innerHeight(),
            $hiddenContent = $this.find('.market-slide__hidden-content');

        if (height - wrapperHeight - 77 <= 0) {
            $hiddenContent.css('height', '68px');
        }
    });
}